import { isEqual } from "es-toolkit";
import { atom } from "jotai";
import { atomFamily } from "jotai/utils";

import { Logger } from "@moment/logging";

import { $singletonRebootContext } from "../reboot";
import { type MdPageCollabConnection } from "./collab.types";
import { type PageRefProps, mdPageAuthorityRef, mdPresenceStoreRef } from "./refs";

const logger = new Logger("collab-connection");

/**
 * The canonical Reboot connection for a specific Markdown page, as identified by workspace slug,
 * document ID, page ID, branch, and SHA.
 *
 * Returns null if the application-wide singleton Reboot `WebContext` is not available.
 */
export const $mdPageCollabConnection = atomFamily((props: PageRefProps) => {
	const connectionAtom = atom((get): MdPageCollabConnection | null => {
		// Get the Reboot context
		const context = get($singletonRebootContext);
		if (!context) {
			logger.warn("RebootContext not available", { ...props });
			return null;
		}

		// Create PageAuthority and PresenceStore references
		const authority = mdPageAuthorityRef(props);
		const presence = mdPresenceStoreRef(props);

		logger.info("Created collab connection", { ...props });

		return { authority, presence, context };
	});

	connectionAtom.debugLabel = `pageCollabConnection/${props.workspaceSlug}/${props.documentId}/${props.pageId}/${props.branch}/${props.sha}`;
	return connectionAtom;
}, isEqual);
